
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";


export const getCustomerInfo = (customerPositionId,summarized) => http({
    url:summarized?ENDPOINTS.afterSalesApi.Summarized: ENDPOINTS.afterSalesApi.customerInfo,
    method: 'get',
    params: {
        customerPositionId 
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const getCustomerInProgressRequests = (CustomerId) => http({
    url: ENDPOINTS.afterSalesApi.customerInProgressRequests,
    method: 'get',
    params: {
        customerPositionId :CustomerId
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const getCustomerPhoneNumbers = (customerPositionId,pageNumber: number, pageSize: number, searchString, orderBy, filterlist) => http({
    url: ENDPOINTS.BaseInformation.CustomerPosition.PhoneNumbers,
    method: 'get',
    params: {
        customerPositionId :customerPositionId,
        PageNumber: pageNumber,
        PageSize: pageSize,
        SearchString: searchString,
        OrderByString: orderBy,
        FilterString: filterlist
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const postCustomerPhoneListApi = (data  ) => http({
    url:  ENDPOINTS.BaseInformation.CustomerPosition.positionContact,
    method: 'post',
    data:data
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const deletePersonContact = (id  ) => http({
    url:  ENDPOINTS.BaseInformation.CustomerPosition.brows,
    method: 'delete',
params:{
    id
}
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const setDefault = (personContactId  ) => http({
    url:  ENDPOINTS.afterSalesApi.SetDefaultContact,
    method: 'put',
params:{
    personContactId
}
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});